const BRIDGE_URL = "http://127.0.0.1:17890";
const STORAGE_KEY = "savedWindowsPrinter";

const requestBridge = async (path, options = {}) => {
  const response = await fetch(`${BRIDGE_URL}${path}`, {
    ...options,
    headers: {
      ...(options.headers || {}),
    },
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(body.message || `Printer bridge gagal dengan status ${response.status}`);
  }
  return body;
};

export const getWindowsPrintBridgeUrl = () => BRIDGE_URL;

export const getSavedWindowsPrinter = () => {
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

export const setSavedWindowsPrinter = (name) => {
  const value = { name: String(name || "").trim() };
  if (!value.name) {
    localStorage.removeItem(STORAGE_KEY);
    return null;
  }
  localStorage.setItem(STORAGE_KEY, JSON.stringify(value));
  return value;
};

export const disconnectWindowsPrinter = () => {
  localStorage.removeItem(STORAGE_KEY);
};

export const isWindowsPrintBridgeAvailable = async () => {
  try {
    const result = await requestBridge("/health");
    return result?.success === true;
  } catch {
    return false;
  }
};

export const listWindowsPrinters = async () => {
  const result = await requestBridge("/printers");
  return Array.isArray(result?.printers) ? result.printers : [];
};

export const sendRawWindowsBytes = async (arrayBuffer, targetPrinterName = null) => {
  const saved = getSavedWindowsPrinter();
  const printerName = targetPrinterName || saved?.name;
  if (!printerName) {
    throw new Error("Belum ada printer Windows yang dipilih.");
  }

  const response = await fetch(`${BRIDGE_URL}/print?printer=${encodeURIComponent(printerName)}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/octet-stream",
    },
    body: arrayBuffer,
  });
  const body = await response.json().catch(() => ({}));
  if (!response.ok || body?.success !== true) {
    throw new Error(body.message || "Printer bridge gagal mengirim nota ke Windows Spooler.");
  }
  return { method: "windows-spooler", success: true, jobId: body.job_id };
};
